"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var TypographyConfig = {
  typescale: 'VDS'
};
var typeScales = ['VDS'];

function settypescale(config) {
  if (!typeScales.includes(config)) return;
  TypographyConfig.typescale = config;
}

function getTypescale(path) {
  return TypographyConfig.typescale;
}

var _default = {
  getTypescale: getTypescale,
  settypescale: settypescale
};
exports["default"] = _default;